import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import Button from '../../components/Button';

import { Content, UploadBannerInput } from './styles';
import StandardContainer from '../../components/StandardContainer';
import Header from '../../components/Header';
import { CheckBox } from '@material-ui/icons';
import Checkbox from '../../components/Checkbox';

interface LocationState {
  id: string;
  type: string;
  imgSquare: number;
}

const BannerUpload = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const { state } = useLocation<LocationState>();

  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState(false);
  const [imgSize, setImgSize] = useState({ height: 0, width: 0 });
  const [imgSquare, setImgSquare] = useState(false);

  const handleImageChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const file = e.target.files[0];

        const img = new Image();
        const _URL = window.URL || window.webkitURL;

        const objectUrl = _URL.createObjectURL(file);
        img.src = objectUrl;

        img.onload = () => {
          const { height, width } = img;

          //console.log({ height, width });
          setImgSize({ height, width });
        };

        setFile(file);
      }
    },
    [setFile, setImgSize],
  );

  useEffect(() => {
    //setImgSquare(false);
    console.log("state", state);

    setImgSquare((prevState) => {
      console.log('Previous State:', prevState);
      const newState = state.imgSquare == 1 ? true : false;
      console.log('New State:', newState);
      return newState;
    });
  }, [])

  useEffect(() => {
    console.log('imgSquare updated:', imgSquare);
  }, [imgSquare])

  const handleUploadImage = useCallback(async () => {
    setLoading(true);
    try {
      if (file) {
        //console.log(imgSize);

        const isToBigDefault = imgSize.width > 1200 || imgSize.height > 640;

        if (isToBigDefault) {
          addToast({
            type: 'error',
            title: 'Imagem muito grande ou invalida :(',
            description: 'Imagem maior que 1200X640',
          });
          setLoading(false);
          return;
        }

        console.log('Sending imgSquare:', imgSquare); 
        const data = new FormData();
        data.append('imageSquare', imgSquare ? 'true' : 'false');
        data.append('banner', file);

        console.log('Sending imgSquare:', imgSquare); 
        await api.patch(`/banners/${state.id}/image`, data);
        history.push('/banner');

        addToast({
          type: 'success',
          title: 'Imagem do banner atualizada!',
        });
      }
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro ao atualizar imagem!',
        description: 'Tente novamente mais tarde :)',
      });
    }

    setLoading(false);
  }, [addToast, file, history, state.id, imgSize, imgSquare]);

  return (
    <StandardContainer>
      <Header />
      <Content>
        <h1>Adicionar imagem do banner</h1>
        <UploadBannerInput>
          <input disabled value={file?.name} />
          <label htmlFor="uploadBanner">
            <FiUpload />
            <input type="file" id="uploadBanner" onChange={handleImageChange} />
          </label>
        </UploadBannerInput>
        {imgSize.width > 0 && imgSize.height > 0 && (
          <span>
            {imgSize.width} x {imgSize.height}
          </span>
        )}
        <Checkbox
          name="imgSquare"
          checked={imgSquare}
          onChecked={() => {

            setImgSquare((prevState) => {
              console.log('Previous State:', prevState);
              const newState = !prevState;
              console.log('New State:', newState);
              return newState;
            });
            
          }}
          checkboxName="Salvar imagem como tipo 'QUADRADA'"
        />
        <Button onClick={handleUploadImage} loading={loading}>
          Salvar
        </Button>
      </Content>
    </StandardContainer>
  );
};

export default BannerUpload;
